const styles = {
  mainContainer: {
    // width: "500px",
    // margin: "auto",
    // position: "absolute",
    // top: "50%",
    // left: "50%",
    // transform: `translate(-50%, -50%)`,
    // border: `1px solid ${COLORS.primary}`,
    // height: "fit-content",
  },
  imgContainer: {
    // display: "flex",
    // justifyContent: "center",
    // padding: "50px 0",
  },
  logo: {
    // width: "52%",
  },
  childContainer: {
    // padding: "10px 45px 0 45px",
  },
};

export default styles;
